"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("../const");
var BWalker = function (resList, node, pos) {
    resList.push({ node: node, pos: pos });
    return false;
};
// const DWalker: nodesWalker = (resList, node, pos) => {
//   resList.push({ node, pos });
//   return Boolean(node.content.childCount);
// };
/**
 * @desc 默认获取直接子节点
 * @param {boolean|nodesWalker} walker true 深度遍历，false 只获取直接子节点，或者自定义walker
 */
var getNodesBetween = function (doc, from, to, walker) {
    if (walker === void 0) { walker = BWalker; }
    var nodes = [];
    doc.nodesBetween(from, to, function (node, pos, parent, index) {
        return walker(nodes, node, pos, parent, index);
    });
    return nodes;
};
var getNodesBefore = function (doc, pos) {
    return getNodesBetween(doc, 0, pos);
};
var checkHasContent = function (nodes) {
    return nodes.some(function (_a) {
        var node = _a.node;
        return node.type.name !== const_1.NODE_NAME.P || node.nodeSize !== const_1.NORMAL_NODE_SIZE;
    });
};
var checkHasContentBefore = function (doc, pos) {
    // 当选区位于节点头时会包含自身，所以-1
    var nodes = getNodesBefore(doc, pos > 0 ? pos - 1 : pos);
    return checkHasContent(nodes);
};
exports.checkHasContentBefore = checkHasContentBefore;
var getExistNodes = function (doc, nodeName) {
    var walker = function (res, curNode, pos) {
        if (curNode.type.name === nodeName) {
            res.push({
                node: curNode,
                pos: pos
            });
        }
        return Boolean(curNode.content.childCount);
    };
    // 确保位置从拥有节点的位置开始，doc默认会有一段paragraph
    return getNodesBetween(doc, 0, doc.nodeSize - 2, walker);
};
exports.getExistNodes = getExistNodes;
// 一些节点(换行符等)并没有文本内容，用空格代替
var constructText = function (node) {
    if (node.textContent)
        return node.textContent;
    var len = node.nodeSize;
    var text = '';
    while (len--) {
        text += ' ';
    }
    return text;
};
var getExistMarks = function (state, markName) {
    var markType = state.schema.marks[markName];
    if (!markType)
        return [];
    var prevParent;
    var prevMark;
    var walker = function (res, curNode, pos, parent) {
        var cMark = curNode.marks.find(function (mark) { return mark.type.name === markName; });
        if (curNode.isLeaf &&
            curNode.marks.length &&
            markType.isInSet(curNode.marks)) {
            if (parent !== prevParent || cMark !== prevMark) {
                res.push({
                    pos: pos,
                    node: state.schema.text(constructText(curNode), curNode.marks),
                    mark: cMark
                });
            }
            else if (cMark === prevMark) {
                var newNode = state.schema.text(res[res.length - 1].node.textContent + constructText(curNode), curNode.marks);
                res[res.length - 1].node = newNode;
            }
        }
        prevParent = parent;
        prevMark = cMark;
        return Boolean(curNode.content.childCount);
    };
    return getNodesBetween(state.doc, 0, state.doc.nodeSize - 2, walker);
};
exports.getExistMarks = getExistMarks;
/**
 * 获取光标所在节点的名称
 */
var getCursorNode = function (view, depth) {
    var _a = view.state.selection, $from = _a.$from, $to = _a.$to;
    if ($from.parent !== $to.parent || $from.parent.type.name === 'doc')
        return false;
    return {
        pos: $from.before(depth),
        node: $from.node(depth)
    };
};
exports.getCursorNode = getCursorNode;
//# sourceMappingURL=query.js.map